interface StateType {
    mainBackground: string;
    bannerUrl: string;
    ruleBackground: string;
    displayBackground: string;
    listBackground: string;
    giftUrl1: string;
    giftUrl2: string;
    giftUrl3: string;
}
type stateKey = keyof StateType;

interface PayloadType {
    key: stateKey;
    value: string;
}

export default {
    state: {
        mainBackground: '',
        bannerUrl: '',
        ruleBackground: '',
        displayBackground: '',
        listBackground: '',
        giftUrl1: '',
        giftUrl2: '',
        giftUrl3: ''
    },
    mutations: {
        setBackgrondValue(state: StateType, playLoad: PayloadType) {
            const { key, value } = playLoad;
            if (state[key]) return;
            state[key] = value;
        }
    },

    namespaced: true
};
